import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { BeheadingInventoryDto } from "./beheading-inventory.dto";

export class BeheadingInventoryResponse extends GlobalResponseObject{
    data?: BeheadingInventoryDto[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: BeheadingInventoryDto[]){
        super(status,intlCode,internalMessage)
        this.data = data;
    }

}